import { Component, Input, OnInit } from '@angular/core';
import { ImageColumnDto } from '@hub/generated/models';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextModule} from 'primeng/inputtext';

@Component({
  selector: 'g-columnIcon',
  templateUrl: './columnImage.component.html'
})
export class ColumnImageComponent {
  @Input() data: ImageColumnDto;
}
